<template>
  <transition name="gotop-fade">
    <div id="GoTop" v-show="visible" @click="GoTop()">
      <span class="glyphicon glyphicon-chevron-up"></span>
    </div>
  </transition>
</template>

<script>
export default {
  name: "GoTop",
  data() {
    return {
      visible: false,
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll, { passive: true });
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      this.visible = window.scrollY > 400;
    },
    GoTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
  },
};
</script>

<style scoped>
#GoTop {
  width: 48px;
  height: 48px;
  position: fixed;
  right: 24px;
  bottom: 32px;
  z-index: 99999999;
  cursor: pointer;
  background: linear-gradient(135deg, #1358fe, #09a1ff);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 16px rgba(19, 88, 254, 0.35);
  transition: transform 0.25s ease, box-shadow 0.25s ease;
}

#GoTop:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 24px rgba(19, 88, 254, 0.45);
}

#GoTop > span {
  color: #fff;
  font-size: 20px;
}

.gotop-fade-enter-active,
.gotop-fade-leave-active {
  transition: opacity 0.3s ease, transform 0.3s ease;
}

.gotop-fade-enter,
.gotop-fade-leave-to {
  opacity: 0;
  transform: translateY(16px);
}
</style>



// WEBPACK FOOTER //
// src/components/GoTop.vue